import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCalendarPlus, faListCheck } from '@fortawesome/free-solid-svg-icons';
import { Product } from '../data/interfaces/Product';
import { Variation } from '../data/interfaces/Variation';
import { getGameColor, getPlatformColor } from '../data/objects/gameColor';
import DownloadOptionsButton from './DownloadOptionsButton';

interface InfoSectionProps {
    product: Product;
    variations: Variation[];
    selectedVariation: Variation;
    handleVariationChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const ProductPageHeaderInfo: React.FC<InfoSectionProps> = ({ product, variations, selectedVariation, handleVariationChange }) => {

    const gameColor = getGameColor(product.game);

    return (
        <div className="card-body">

            <div className="d-flex align-items-center">
                <div
                    className="game-indicator"
                    style={{
                        backgroundColor: gameColor
                    }}
                ></div>
                <p className="card-text m-0 kanit-regular" style={{ color: 'gray' }}>{product.game}</p>
            </div>
            <h1 className="card-text display-5 kanit-regular">{product.title.toUpperCase()}</h1>

            {variations.length > 1 && (
                <select
                    className="form-select mt-3"
                    aria-label="Default select example"
                    onChange={handleVariationChange}
                    value={selectedVariation.variationId}>
                    {variations.map((variation) => (
                        <option key={variation.variationId} value={variation.variationId}>
                            {variation.title}
                        </option>
                    ))}
                </select>
            )}

            <p className="card-text lead my-3 ubuntu-regular">{product.description}</p>

            <div className="d-flex align-items-center my-3">
                {product.platforms.map((platform, index) => (
                    <span
                        key={index}
                        className="platform-pill"
                        style={{
                            backgroundColor: getPlatformColor(platform),
                        }}
                    >
                        {platform}
                    </span>
                ))}
            </div>

            <div className="version-info kanit-light-italic">
                <FontAwesomeIcon icon={faListCheck} />
                <span>Version {selectedVariation.version}</span>
            </div>

            <div className="dates-info kanit-light-italic">
                <FontAwesomeIcon icon={faCalendarDays} />
                <span>Posted: {selectedVariation.datePosted}</span>
            </div>

            {selectedVariation.dateUpdated && (
                <div className="dates-info kanit-light-italic">
                    <FontAwesomeIcon icon={faCalendarPlus} />
                    <span>Updated: {selectedVariation.dateUpdated}</span>
                </div>
            )}

            <DownloadOptionsButton
                variationPath={`/assets/releases/${selectedVariation.releaseId}/variations/v${selectedVariation.variationId}/downloads`}
                variation={selectedVariation}
            />
        </div>
    );
};

export default ProductPageHeaderInfo;
